import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Typography,
} from "@mui/material";

export default function ContactFAQ() {
  const faqs = [
    {
      q: "How quickly will someone contact me?",
      a: "Our real estate advisors typically respond within one business day to ensure timely and personalized assistance.",
    },
    {
      q: "Do you work with international clients?",
      a: "Yes. Vision X Nexus assists both local and international buyers and investors, providing end-to-end support for UAE real estate transactions.",
    },
    {
      q: "Is there any consultation fee?",
      a: "No. Our initial consultation is completely complimentary and comes with no obligation.",
    },
    {
      q: "What types of properties do you specialize in?",
      a: "We specialize in luxury residential properties, commercial real estate, off-plan developments, and high-return investment opportunities across Sharjah, Dubai, and Ajman.",
    },
    {
      q: "Can you help with property investment advisory?",
      a: "Absolutely. Our consultants provide market insights, ROI analysis, and strategic guidance to help clients make confident investment decisions.",
    },
    {
      q: "Who designed and developed this website?",
      a: (
        <>
          This website was professionally designed and developed by{" "}
          <a
            href="https://oglitz.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "var(--color-gold)",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Oglitz Software Pvt. Ltd.
          </a>
          , a digital solutions company specializing in premium UI/UX design,
          scalable web applications, and high-performance business websites.
        </>
      ),
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)",
        position: "relative",
      }}
    >
      <Container maxWidth="md">
        {/* HEADER */}
        <Box
          sx={{
            maxWidth: 560,
            mx: "auto",
            textAlign: "center",
            mb: 7,
          }}
        >
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.3em",
              fontSize: 12,
              mb: 2,
            }}
          >
            FAQs
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-primary)",
              fontSize: { xs: "2rem", md: "2.6rem" },
              fontWeight: 600,
              lineHeight: 1.15,
            }}
          >
            Frequently Asked{" "}
            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Questions
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-muted)",
              fontSize: 15,
              lineHeight: 1.8,
              mt: 2,
            }}
          >
            Everything you need to know about working with our real estate
            experts.
          </Typography>
        </Box>

        {/* FAQ LIST */}
        {faqs.map((item, i) => (
          <Accordion
            key={i}
            disableGutters
            elevation={0}
            sx={{
              mb: 2.5,
              borderRadius: 3,
              overflow: "hidden",
              backgroundColor: "var(--color-white)",
              border: "1px solid rgba(207,172,106,0.35)",
              boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
              transition: "all 0.3s ease",
              "&:before": { display: "none" },

              "&:hover": {
                boxShadow: "0 18px 45px rgba(0,0,0,0.12)",
              },

              "&.Mui-expanded": {
                borderColor: "var(--color-gold)",
                boxShadow: "0 22px 60px rgba(0,0,0,0.16)",
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon sx={{ color: "var(--color-gold)" }} />
              }
              sx={{ px: { xs: 2.5, md: 3 }, py: 2.2 }}
            >
              <Typography
                sx={{
                  color: "var(--color-text-primary)",
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {item.q}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ px: { xs: 2.5, md: 3 }, pb: 3, pt: 0 }}>
              <Typography
                sx={{
                  color: "var(--color-text-muted)",
                  fontSize: 15,
                  lineHeight: 1.8,
                }}
              >
                {item.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
